import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../../../fc-core/src/component-interface';
import { pluck } from '../../../../../fc-core/src/lib';

var UNDEF,
    setterGetter = function setterGetter(a, b) {
  return a = 'comp_' + a, b && (this.config[a] = b), (b || !this.config[a]) && this || this.config[a];
},
    _getTranslationString = function _getTranslationString(a, b) {
  return ['T', a, ',', b].join('');
},
    _getTranslation = function _getTranslation(a) {
  return -a.getTranslation();
},
    calculateTranslation = function calculateTranslation(a) {
  return _getTranslationString(_getTranslation(a.h), _getTranslation(a.v));
},
    getHVOb = function getHVOb(a, b) {
  return {
    h: a,
    v: b
  };
},
    groupsArr = ['columnShadowVcanvasGroup', 'columnVcanvasGroup', 'areaShadowVcanvasGroup', 'areaVcanvasGroup', 'lineShadowVcanvasGroup', 'lineVcanvasGroup', 'defaultShadowVcanvasGroup', 'defaultVcanvasGroup', 'sumLabelsLayer', 'vcanvasLabelGroup'],
    createGroup = function createGroup(a, b, c) {
  var d = c.getFromEnv('animationManager');
  return d.setAnimation({
    el: 'group',
    attr: {
      name: a
    },
    container: b,
    state: 'appearing',
    component: c,
    label: 'group'
  });
},
    limitToBeUpdated = function limitToBeUpdated(a) {
  return !/category/i.test(a.getName());
};

var VISIBLE = 'visible',
    REMOVED = 'removed',
    DATASET = 'dataset';

var VirtualCanvas =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(VirtualCanvas, _ComponentInterface);

  function VirtualCanvas() {
    _classCallCheck(this, VirtualCanvas);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualCanvas).apply(this, arguments));
  }

  _createClass(VirtualCanvas, [{
    key: "getName",
    value: function getName() {
      return 'virtualCanvas';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'canvas';
    }
  }, {
    key: "xAxis",
    value: function xAxis(a) {
      var b = setterGetter.call(this, 'xAxis', a);
      return a && this.listenToAxis(a), a && this.addToEnv('xAxis', a), b;
    }
  }, {
    key: "yAxis",
    value: function yAxis(a) {
      var b = setterGetter.call(this, 'yAxis', a);
      return a && this.listenToAxis(a), a && this.addToEnv('yAxis', a), b;
    }
  }, {
    key: "paper",
    value: function paper(a) {
      return setterGetter.call(this, 'paper', a);
    }
  }, {
    key: "canvas",
    value: function canvas(a) {
      return setterGetter.call(this, 'canvas', a);
    }
  }, {
    key: "configure",
    value: function configure() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = b.getFromEnv('chartConfig'),
          d = b.config;
      Object.assign(d, a), d.transposeAxis = c.transposeAxis, this._mapChildren(function (a) {
        a.getState(REMOVED) || a.getType() === DATASET || a.configure && a.configure();
      });
    }
  }, {
    key: "getHorizontalVerticalAxes",
    value: function getHorizontalVerticalAxes() {
      var a = this,
          b = a.xAxis(),
          c = a.yAxis();
      return c.config.isVertical ? getHVOb(b, c) : getHVOb(c, b);
    }
  }, {
    key: "preDraw",
    value: function preDraw() {
      this._mapChildren(function (a) {
        a.getState('removed') || 'dataset' === a.getType() || a.setVisibility && a.setVisibility();
      });

      var a,
          b = this.config.transposeAxis,
          c = this.getFromEnv('chart'),
          _this$getAxisValuePad = this.getAxisValuePadding(),
          d = _this$getAxisValuePad.left,
          e = _this$getAxisValuePad.right,
          f = _this$getAxisValuePad.top,
          g = _this$getAxisValuePad.bottom;

      a = this.getDataLimits(!b), a.min !== 1 / 0 || a.max !== -Infinity ? (this._setYAxisLimits(a.min, a.max), c._storeIntialLimit && c._storeIntialLimit(a.min, a.max)) : (this._setYAxisLimits(UNDEF, UNDEF), c._storeIntialLimit && c._storeIntialLimit(UNDEF, UNDEF)), this._setXAxisLimits(a.xMin, a.xMax), this._setAxisValuePadding(d, e, f, g);
    }
  }, {
    key: "childChanged",
    value: function childChanged() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b,
          c = this,
          d = c.config,
          e = d.transposeAxis;
      !1 !== a.dataLimitChanged && (b = c.getDataLimits(!e), e && (b.min !== d.range.min || b.max !== d.range.max) && (d.range.min = b.min, d.range.max = b.max, this.getFromEnv('yAxis').resetStoredLimits(), b.min !== 1 / 0 || b.max !== -Infinity ? c._setYAxisLimits(b.min, b.max) : c._setYAxisLimits(UNDEF, UNDEF)), (b.xMin !== d.range.xMin || b.xMax !== d.range.xMax) && (d.range.xMin = b.xMin, d.range.xMax = b.xMax, this.getFromEnv('xAxis').resetStoredLimits(), c._setXAxisLimits(b.xMin, b.xMax))), c.asyncDraw();
    }
  }, {
    key: "_setAxisValuePadding",
    value: function _setAxisValuePadding(a, b, c, d) {
      this.getFromEnv('xAxis').setAxisPadding(a, b), c && d && this.getFromEnv('yAxis').setAxisPadding(a, b);
    }
  }, {
    key: "getAxisValuePadding",
    value: function getAxisValuePadding() {
      var a = Math.max;
      var b = {},
          c = -Infinity,
          d = -Infinity,
          e = -Infinity,
          f = -Infinity;
      return this._mapChildren(function (g) {
        g.getState(REMOVED) || (b = g.getAxisValuePadding && g.getAxisValuePadding() || {}, c = a(c, b.left || -Infinity), d = a(d, b.right || -Infinity), e = a(e, b.top || -Infinity), f = a(f, b.bottom || -Infinity));
      }), c === -Infinity && (c = 0), d === -Infinity && (d = 0), e === -Infinity && (e = 0), f === -Infinity && (f = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = c, this.config.padding.right = d, this.config.padding.top = e, this.config.padding.bottom = f), {
        left: c,
        right: d,
        top: e,
        bottom: f
      };
    }
  }, {
    key: "_setYAxisLimits",
    value: function _setYAxisLimits(a, b) {
      var c = this.getFromEnv('yAxis');
      limitToBeUpdated(c) && c.setDataLimit(b, a);
    }
  }, {
    key: "_setXAxisLimits",
    value: function _setXAxisLimits(a, b) {
      var c = this.getFromEnv('xAxis');
      limitToBeUpdated(c) && (b !== -Infinity || a !== +Infinity ? c.setDataLimit(b, a) : c.setDataLimit(UNDEF, UNDEF));
    }
  }, {
    key: "getDataLimits",
    value: function getDataLimits(a) {
      var b,
          c,
          d,
          e = Math.max,
          f = this,
          g = f.getFromEnv('chart'),
          h = -Infinity,
          i = +Infinity,
          j = h,
          k = i,
          l = i,
          m = h,
          n = function n(a) {
        var b = Math.min;
        c = pluck(a.xMax, h), d = pluck(a.xMin, i), j = e(j, a.max), k = b(k, a.min), m = e(m, c), l = b(l, d);
      };

      return f._mapChildren(function (c) {
        c.getDataLimits && !c.getState(REMOVED) && (a || c.getState(VISIBLE)) && (b = c.getDataLimits(a), n(b));
      }), this.config.range || (this.config.range = {}, this.config.range.min = k, this.config.range.max = j, this.config.range.xMin = l, this.config.range.xMax = m), g.config.yMax = j, g.config.yMin = k, {
        min: k,
        max: j,
        xMin: l,
        xMax: m
      };
    }
  }, {
    key: "listenToAxis",
    value: function listenToAxis(a) {
      var b,
          c = this;
      b = function b() {
        c.getState('drawn') && c.asyncDraw();
      }, this.getState('visiblerangeset' + a.getId()) || (this.setState('visiblerangeset' + a.getId(), !0), c.addExtEventListener('visiblerangeset', b, a));
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      var a = this,
          b = a.getLinkedParent();
      a.getChildContainer('columnShadowVcanvasGroup') || a.addChildContainer('columnShadowVcanvasGroup', createGroup('vcanvas-column-shadow', b.getChildContainer('columnShadowGroup'), a)), a.getChildContainer('columnVcanvasGroup') || a.addChildContainer('columnVcanvasGroup', createGroup('vcanvas-column-plot', b.getChildContainer('columnGroup'), a)), a.getChildContainer('areaShadowVcanvasGroup') || a.addChildContainer('areaShadowVcanvasGroup', createGroup('vcanvas-area-shadow', b.getChildContainer('areaShadowGroup'), a)), a.getChildContainer('areaVcanvasGroup') || a.addChildContainer('areaVcanvasGroup', createGroup('vcanvas-area-plot', b.getChildContainer('areaGroup'), a)), a.getChildContainer('lineShadowVcanvasGroup') || a.addChildContainer('lineShadowVcanvasGroup', createGroup('vcanvas-line-shadow', b.getChildContainer('lineShadowGroup'), a)), a.getChildContainer('lineVcanvasGroup') || a.addChildContainer('lineVcanvasGroup', createGroup('vcanvas-line-plot', b.getChildContainer('lineGroup'), a)), a.getChildContainer('defaultShadowVcanvasGroup') || a.addChildContainer('defaultShadowVcanvasGroup', createGroup('vcanvas-default-shadow', b.getChildContainer('defaultShadowGroup'), a)), a.getChildContainer('defaultVcanvasGroup') || a.addChildContainer('defaultVcanvasGroup', createGroup('vcanvas-default-plot', b.getChildContainer('defaultGroup'), a)), a.getChildContainer('vcanvasLabelGroup') || a.addChildContainer('vcanvasLabelGroup', createGroup('vcanvas-label', b.getChildContainer('datalabelsGroup'), a)), a.getChildContainer('columnTrendGroup') || a.addChildContainer('columnTrendGroup', createGroup('columnTrendGroup', a.getChildContainer('columnVcanvasGroup'), a)), a.getChildContainer('sumLabelsLayer') || a.addChildContainer('sumLabelsLayer', createGroup('vcanvas-sumLabelsLayer', b.getChildContainer('sumLabelsLayer'), a));
    }
  }, {
    key: "applyTranslation",
    value: function applyTranslation() {
      var a = this,
          b = a.getHorizontalVerticalAxes(),
          c = calculateTranslation(b),
          d = function d(b) {
        b = a.getChildContainer(b), b.attr({
          transform: c
        });
      };

      a.createContainer(), groupsArr.forEach(function (a) {
        d(a);
      });
    }
  }, {
    key: "draw",
    value: function draw() {
      this.applyTranslation(), this.setState('drawn', !0);
    }
  }, {
    key: "getCanvasPadding",
    value: function getCanvasPadding() {
      var a,
          b,
          c = this,
          d = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return c._mapChildren(function (c) {
        if (c.getCanvasPadding && !c.getState(REMOVED)) for (b in a = c.getCanvasPadding() || {}, a) {
          a.hasOwnProperty(b) && (d[b] = Math.max(a[b], d[b]));
        }
      }), d;
    }
  }, {
    key: "rtShiftAnim",
    value: function rtShiftAnim(a, b) {
      var c,
          d = this,
          e = d.getFromEnv('xAxis'),
          f = d.getFromEnv('yAxis'),
          g = e.getPixel(1) - e.getPixel(0),
          h = f.getPixel(1) - f.getPixel(0),
          i = d.getFromEnv('animationManager');
      a = (a || 0) * g, b = (b || 0) * h, c = _getTranslationString(a, b), groupsArr.forEach(function (a) {
        d.getChildContainer(a).attr({
          transform: c
        }), i.setAnimation({
          el: d.getChildContainer(a),
          attrs: {
            transform: 'T0,0'
          }
        });
      });
    }
  }]);

  return VirtualCanvas;
}(ComponentInterface);

export default VirtualCanvas;